import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-work-classification-list',
    templateUrl: './work-classification-list.component.html',
    styleUrls: ['./work-classification-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WorkClassificationListComponent {

}
